import { Grid, Skeleton } from '@fs/zion-ui'
import React from 'react'

type Props = {
  short?: boolean
  variant: 'split' | 'chip'
}

export default function PersonQualityScoreButtonSkeleton({ short, variant }: Props): JSX.Element {
  if (variant === 'split') {
    return (
      <div style={{ width: 200 }}>
        <Grid gutters="pico">
          <Skeleton.Paragraph size="md" data-testid="loading-quality-score-action-button" />
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <Skeleton.Button minWidth={200} />
        </Grid>
      </div>
    )
  }
  return <Skeleton.Chip data-testid="loading-quality-score-action-chip" width={short ? 90 : 130} />
}
